import { createStore, applyMiddleware, combineReducers } from "redux";
import * as Sentry from "@sentry/react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import authReducer from "./reducers/authReducer";
import teacherReducer from "./reducers/teacherReducer";
import adminReducer from "./reducers/adminReducer";

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const rootReducer = combineReducers({
  teacherReducer,
  authReducer,
  adminReducer,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk), sentryReduxEnhancer),
);

export { store };
